<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {
    
  }
}
</script>

<style>
*{
  margin: 0;
  padding:0
}
html,body,#app{
  height: 100%;
  box-sizing: border-box;
  margin: 0;
}
</style>
<style>
 @font-face { 
       font-family: "Montserrat";
       src: url("../src/assets/fonts/Montserrat-Regular.27e50ffd.otf"); 
       font-weight: normal;
   }
</style>
